export const stateToTimezone: Record<string, Record<string, string[]>> = {
  US: {
    // States
    AL: ["America/Chicago"],
    AK: ["America/Anchorage", "America/Adak"],
    AZ: ["America/Phoenix"],
    AR: ["America/Chicago"],
    CA: ["America/Los_Angeles"],
    CO: ["America/Denver"],
    CT: ["America/New_York"],
    DE: ["America/New_York"],
    DC: ["America/New_York"],
    FL: ["America/New_York", "America/Chicago"],
    GA: ["America/New_York"],
    HI: ["Pacific/Honolulu"],
    ID: ["America/Boise", "America/Los_Angeles"], // MT primary, PT secondary
    IL: ["America/Chicago"],
    IN: ["America/Indiana/Indianapolis", "America/Chicago"], // ET primary
    IA: ["America/Chicago"],
    KS: ["America/Chicago", "America/Denver"], // CT primary
    KY: ["America/New_York", "America/Chicago"], // ET primary
    LA: ["America/Chicago"],
    ME: ["America/New_York"],
    MD: ["America/New_York"],
    MA: ["America/New_York"],
    MI: ["America/Detroit", "America/Menominee"], // ET primary
    MN: ["America/Chicago"],
    MS: ["America/Chicago"],
    MO: ["America/Chicago"],
    MT: ["America/Denver"],
    NE: ["America/Chicago", "America/Denver"], // CT primary
    NV: ["America/Los_Angeles", "America/Denver"], // PT primary
    NH: ["America/New_York"],
    NJ: ["America/New_York"],
    NM: ["America/Denver"],
    NY: ["America/New_York"],
    NC: ["America/New_York"],
    ND: ["America/Chicago", "America/Denver"], // CT primary
    OH: ["America/New_York"],
    OK: ["America/Chicago"],
    OR: ["America/Los_Angeles", "America/Boise"], // PT primary
    PA: ["America/New_York"],
    RI: ["America/New_York"],
    SC: ["America/New_York"],
    SD: ["America/Chicago", "America/Denver"], // CT primary
    TN: ["America/Chicago", "America/New_York"], // CT primary
    TX: ["America/Chicago", "America/Denver"], // CT primary
    UT: ["America/Denver"],
    VT: ["America/New_York"],
    VA: ["America/New_York"],
    WA: ["America/Los_Angeles"],
    WV: ["America/New_York"],
    WI: ["America/Chicago"],
    WY: ["America/Denver"],

    // Territories
    PR: ["America/Puerto_Rico"],
    GU: ["Pacific/Guam"],
    VI: ["America/St_Thomas"],
    AS: ["Pacific/Pago_Pago"],
    MP: ["Pacific/Saipan"],

    // Freely Associated States (optional)
    FM: ["Pacific/Chuuk", "Pacific/Pohnpei", "Pacific/Kosrae"], // Primary → Chuuk
    MH: ["Pacific/Majuro", "Pacific/Kwajalein"], // Primary → Majuro
    PW: ["Pacific/Palau"],
  },
};

export const timezoneToRegion: Record<string, Record<string, string>> = {
  US: {
    // Eastern
    "America/New_York": "Eastern",
    "America/Detroit": "Eastern",
    "America/Indiana/Indianapolis": "Eastern",
    "America/Indiana/Marengo": "Eastern",
    "America/Indiana/Petersburg": "Eastern",
    "America/Indiana/Vevay": "Eastern",
    "America/Indiana/Vincennes": "Eastern",
    "America/Indiana/Winamac": "Eastern",
    "America/Kentucky/Louisville": "Eastern",
    "America/Kentucky/Monticello": "Eastern",

    // Central
    "America/Chicago": "Central",
    "America/Indiana/Knox": "Central",
    "America/Indiana/Tell_City": "Central",
    "America/Menominee": "Central",
    "America/North_Dakota/Beulah": "Central",
    "America/North_Dakota/Center": "Central",
    "America/North_Dakota/New_Salem": "Central",

    // Mountain
    "America/Denver": "Mountain",
    "America/Boise": "Mountain",
    "America/Phoenix": "Mountain",

    // Pacific
    "America/Los_Angeles": "Pacific",

    // Territories
    "America/Puerto_Rico": "Atlantic",
    "America/St_Thomas": "Atlantic",
    "Pacific/Guam": "Guam",
    "Pacific/Saipan": "Northern Mariana Islands",
    "Pacific/Pago_Pago": "American Samoa",

    // Alaska / Hawaii (optional if included)
    "America/Anchorage": "Alaska",
    "America/Adak": "Hawaii-Aleutian",
    "Pacific/Honolulu": "Hawaii",

    // Freely Associated States (optional)
    "Pacific/Chuuk": "Micronesia",
    "Pacific/Pohnpei": "Micronesia",
    "Pacific/Kosrae": "Micronesia",
    "Pacific/Majuro": "Marshall Islands",
    "Pacific/Kwajalein": "Marshall Islands",
    "Pacific/Palau": "Palau",
  },
};
